import React from "react";
import { connect } from "react-redux";

import TopFooter from "./TopFooter/TopFooter";
import BottomFooter from "./BottomFooter/BottomFooter";

import "./Footer.scss";

const Footer = (props) => {
  const {
    siteName,
    datiFarmacia,
    logoImage,
    isCheckout,
    primaryColor,
    showDiscountsLinkInFooter,
  } = props;

  return (
    <footer>
      <TopFooter
        isCheckout={isCheckout}
        datiFarmacia={datiFarmacia}
        logoImage={logoImage}
        siteName={siteName}
        primaryColor={primaryColor}
        showDiscountsLinkInFooter={showDiscountsLinkInFooter}
      />
      <BottomFooter primaryColor={primaryColor} datiFarmacia={datiFarmacia} />
    </footer>
  );
};

const mapStateToProps = (state) => ({
  siteName: state.template.singleTemplate.siteName,
  datiFarmacia: state.template.singleTemplate,
  logoImage:
    state.template.singleTemplate.logoFooterImage ||
    state.template.singleTemplate.logoImage,
  primaryColor: state.template.singleTemplate.brandColor,
  showDiscountsLinkInFooter:
    state.template.singleTemplate.showDiscountsLinkInFooter,
  feedaty: {
    enabled: state.template.singleTemplate.hasFeedaty,
    widgetId: state.template.singleTemplate.feedaty.widgetId,
    siteKey: state.template.singleTemplate.feedaty.siteKey,
  },
});

export default connect(mapStateToProps)(Footer);
